import React from 'react';

import { NeutralColorToken, TextButton, Type } from '@robinhood/design';

import { TextStyle } from 'src/constants/styles';

const StudentReferralDisclosure = () => {
  return (
    <div css={TextStyle.textCenter}>
      <Type.Text size='S' color={NeutralColorToken.Fg3}>
        {'By continuing, you agree to the '}
        <TextButton
          label='Robinhood User Account Agreement'
          color={NeutralColorToken.Fg3}
          type='anchor'
          href='https://cdn.robinhood.com/assets/robinhood/legal/robinhood-user-account-agreement.pdf'
          target='_blank'
          rel='noopener noreferrer'
        />
        {' and '}
        <TextButton
          label='Privacy Policy'
          color={NeutralColorToken.Fg3}
          type='anchor'
          href='https://robinhood.com/us/en/support/articles/privacy-policy/'
          target='_blank'
          rel='noopener noreferrer'
        />
        {
          '. You acknowledge that your referrer will receive information about your application status through their receipt of a reward.'
        }
      </Type.Text>
    </div>
  );
};

export default StudentReferralDisclosure;
